module.exports = __webpack_public_path__ + "./img/dynamic.b881d084ac0dc732b709a0005d679730.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Briefcase/entry/icons/dynamic.png
// module id = ./src/containers/Briefcase/entry/icons/dynamic.png
// module chunks = 0